module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-1 left-column"
  }, [_c('back-btn'), _vm._v(" "), _c('discover-nav'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-1 pull-right summary-right-column"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.data.epigrams), function(epigram) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": "{ name: 'theme', params: { theme: data.slug, themeId: data.id, id: epigram.id }}"
      }
    }, [_vm._v("\n                        " + _vm._s(epigram.title) + "\n                      ")])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "small-img-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.summaryImgUrl
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("L’Anthologie"), _c('br'), _vm._v(" Palatine & découverte.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8537cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SummaryComponent.vue
// module id = 104
// module chunks = 0